import useClusterConfig from 'hooks/useClusterConfig';

export type Config = {
  stream_id: string;
};

const INVESTIGATION_EVENTS_STREAM_CONFIG = 'org.graylog.plugins.securityapp.migrations.InvestigationEventsStreamConfig';

const useInvestigationsEventsConfig = (): { data: Config; isInitialLoading: boolean } =>
  useClusterConfig<Config>(INVESTIGATION_EVENTS_STREAM_CONFIG);
export default useInvestigationsEventsConfig;
